import React from 'react';
import classNames from 'classnames';
import styles from './assets/program-book-target.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {}

export interface DispatchProps {}

interface RouteParams {}

export interface OwnProps extends RouteComponentProps<RouteParams> {}
export interface Props extends StateProps, DispatchProps, OwnProps {}

const PBTargetCreateScreen: React.FunctionComponent<Props> = () => {
    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'Program book', path: routes.PROGRAM_BOOK_CREATE },
                    { name: `CREATE A NEW TARGET`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}> </div>
        </AdminLayout>
    );
};

export default PBTargetCreateScreen;
